import React from 'react'

const Contact = () => {
  return (
    <div>Contact page</div>
  )
}

export default Contact